export default __webpack_public_path__ + "static/media/imgGreenGap.3363fe7b.png";